import {ReactSession} from "../../utils/ReactSession.jsx";
import {AES, enc} from "crypto-js";

const NoticeBanner = (props) => {

    let dData, headerData2;
    if (ReactSession.get("PAL") != null) {
        let bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    return (
        <div style={{
            backgroundColor: "var(--color-bg-input)",
            borderBottom: "2px solid var(--color-primary)",
            fontSize: "15px",
            color: "var(--color-primary)",
            fontWeight: "500",
            height: "58px",
            display: "flex",
            alignItems: "center"
        }}
             className={"text-center"}>
            <div className="container-fluid">
                <span className="fw-bold me-2" style={{color: "var(--color-primary)"}}>
                    {dData?.notice_message ? dData.notice_message : ""}
                </span>
            </div>
        </div>
    );
};

export default NoticeBanner;